import { useState } from "react";

export default function SortableTable({ columns, data, renderRow }) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  function getNestedValue(obj, path) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  }

  const sortedData = [...data].sort((a, b) => {
    if (!sortConfig.key) return 0;
    let aValue = getNestedValue(a, sortConfig.key);
    let bValue = getNestedValue(b, sortConfig.key);

    if (typeof aValue === "string") aValue = aValue.toLowerCase();
    if (typeof bValue === "string") bValue = bValue.toLowerCase();

    if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  return (
    <table className="sortable-table">
      <thead>
        <tr>
          {columns.map(col => (
            <th
              key={col.key}
              width={col.width}
              title={col.title}
              onClick={() => col.sortable !== false && requestSort(col.key)}
              style={{ cursor: col.sortable === false ? "default" : "pointer" }}
            >
              {col.label}
              {sortConfig.key === col.key && (
                <span>
                  {sortConfig.direction === "asc" ? (
                    <i className="sort-icon fa-solid fa-caret-up"></i>
                  ) : (
                    <i className="sort-icon fa-solid fa-caret-down"></i>
                  )}
                </span>              
              )}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {sortedData.map((row, idx) => renderRow(row, idx))}
      </tbody>
    </table>
  );
}
